import React from 'react'
import PropTypes from "prop-types"
import { Button } from './Button'
import { Link } from "gatsby"
import parse from 'html-react-parser'
import './scss/ImageTile.scss'

/**
 * Image componant to be used across the website when ever an image is to be rendered.
 * 
 * @param {object} image the image object must contain both desktop and mobile images
 * @param {string} link the url the image will go to if clickable
 * @param {string} text the text to be displayed on the button
 * @param {boolean} button determines if there is a button or not on the image
 * @param {string} title the text to be displayed over the image
 * @param {string} alt the alt text of the image
 * @param {object} newWindow determines if the link should open in a new tab or not
 * @returns a rendered tile image
 */
export const ImageTile = ({ image, link, text, button, title, alt, newWindow }) => {
  return (
    <div className='image__tile'>
      {link && link.includes('https') ?
        <a target="_blank" href={link} rel="noreferrer">{title && <div className='image__title'><h3>{parse(title)}</h3><Button text={text} /></div>}
          <picture>
            <source media="(min-width:650px)" srcSet={image.desktop} />
            <img src={image.mobile} alt={alt} style={{ width: '100%' }} />
          </picture></a>
        : button ?
          <Link to={link}><div className='image__title'><h3>{parse(title)}</h3><Button text={text} /></div>
            <picture>
              <source media="(min-width:650px)" srcSet={image.desktop} />
              <img src={image.mobile} alt={alt} style={{ width: '100%' }} />
            </picture>
          </Link> : link !== null ? newWindow ?
            <a target="_blank" href={link} rel="noreferrer">{title && <div className='image__title'><h3>{parse(title)}</h3></div>}
              <picture>
                <source media="(min-width:650px)" srcSet={image.desktop} />
                <img src={image.mobile} alt={alt} style={{ width: '100%' }} />
              </picture></a>
            : <Link to={link}>
              {title && <div className='image__title'><h3>{parse(title)}</h3></div>}
              <picture>
                <source media="(min-width:650px)" srcSet={image.desktop} />
                <img src={image.mobile} alt={alt} style={{ width: '100%' }} />
              </picture>
            </Link>
            : <picture>
              <source media="(min-width:650px)" srcSet={image.desktop} />
              <img src={image.mobile} alt={alt} style={{ width: '100%' }} />
            </picture>
      }

    </div>
  )
}

ImageTile.propTypes = {
  image: PropTypes.object.isRequired,
  link: PropTypes.string,
  text: PropTypes.string,
  button: PropTypes.bool,
  title: PropTypes.string,
  alt: PropTypes.string,
  newWindow: PropTypes.bool
}